import React from "react";
import "./App.css";
import resume from "./data/resume";

// Reusable Components (memoized for small perf wins)
const SkillPill = React.memo(({ text }) => (
  <span className="skill-pill" role="listitem">
    {text}
  </span>
));

const ExperienceCard = React.memo(({ item }) => (
  <div className="card" aria-label={`${item.company} - ${item.role}`}>
    <h3>{item.role}</h3>
    <div className="company">{item.company}</div>
    <div className="duration">{item.duration}</div>
    <div className="location">{item.location}</div>
    <ul>
      {item.roles.map((role, i) => (
        <li key={`${item.company}-role-${i}`}>{role}</li>
      ))}
    </ul>
  </div>
));

const ProjectCard = React.memo(({ project }) => (
  <div className="card" aria-label={`${project.client} project`}>
    <h3>{project.client}</h3>
    <div className="duration">{project.duration}</div>
    <ul>
      {project.responsibilities.map((r, i) => (
        <li key={`${project.client}-resp-${i}`}>{r}</li>
      ))}
    </ul>
  </div>
));

function App() {
  return (
    <div className="background">
      <div className="app">
        <header className="header">
          <h1>{resume.name}</h1>
          <p className="title">{resume.title}</p>
          <div className="contact">
            <span>{resume.contact.location}</span> | {" "}
            <a href={`mailto:${resume.contact.email}`}>{resume.contact.email}</a> | {" "}
            <a href={resume.contact.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a> | {" "}
            <a href={resume.contact.github} target="_blank" rel="noopener noreferrer">GitHub</a>
          </div>
        </header>

        <section className="section">
          <div className="summary card">
            <h2>Summary</h2>
            <p>{resume.summary}</p>
          </div>

          <div className="highlights card">
            <h2>Highlights</h2>
            <ul>
              {resume.highlights.map((h, i) => (
                <li key={i}>{h}</li>
              ))}
            </ul>
          </div>

          <div className="skills card" aria-label="technical skills">
            <h2>Technical Skills</h2>
            <div className="skills-container">
              {resume.skills.map((s, i) => (
                <SkillPill text={s} key={`skill-${i}`} />
              ))}
            </div>
          </div>

          <div className="experience-section">
            <h2>Work Experience</h2>
            {resume.experience.map((e, i) => (
              <ExperienceCard item={e} key={`${e.company}-${i}`} />
            ))}
          </div>

          <div className="projects-section">
            <h2>Projects</h2>
            {resume.projects.map((p, i) => (
              <ProjectCard project={p} key={`${p.client}-${i}`} />
            ))}
          </div>

          <div className="certifications card">
            <h2>Certifications</h2>
            <ul>
              {resume.certifications.map((c, i) => (
                <li key={i}>{c}</li>
              ))}
            </ul>
          </div>

          <div className="education card">
            <h2>Education</h2>
            {resume.education.map((edu, i) => (
              <div key={i}>
                <strong>{edu.degree}</strong> - {edu.institution} ({edu.duration})
                <div>Grade: {edu.grade}</div>
                <div>Courses: {edu.courses.join(", ")}</div>
              </div>
            ))}
          </div>

          <div className="achievements card">
            <h2>Achievements</h2>
            <ul>
              {resume.achievements.map((a, i) => (
                <li key={i}>{a}</li>
              ))}
            </ul>
          </div>

          <div className="softskills card">
            <h2>Soft Skills</h2>
            <ul>
              {resume.softSkills.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ul>
          </div>

          <div className="references card">
            <h2>References</h2>
            {resume.references.map((r, i) => (
              <div key={i}>
                <strong>{r.name}</strong> ({r.role}) - {r.email} / {r.phone}
              </div>
            ))}
          </div>

          <div className="interests card">
            <h2>Interests</h2>
            <ul>
              {resume.interests.map((i, idx) => (
                <li key={idx}>{i}</li>
              ))}
            </ul>
          </div>
        </section>

        <footer className="footer">
          Built with ❤️ using React
        </footer>
      </div>

      <div className="particles" aria-hidden="true" role="presentation">
        {[...Array(30)].map((_, i) => (
          <div key={`particle-${i}`} className="particle" />
        ))}
      </div>
    </div>
  );
}

export default App;
